import * as React from "react";
const SvgAnalytics24 = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 19V5H6V19H4ZM10 19V11H12V19H10ZM16 19V8H18V19H16Z", fill: "currentColor" }));
export default SvgAnalytics24;
